import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo } from 'react';
import { animated, useSpring } from 'react-spring';
import styled from 'styled-components';
import { flexbox, layout, space } from 'styled-system';
import { onEnterOrSpacePress } from '@hivebrite/utils';
import { Box } from "../../box/src";
import { LinkSimple } from "../../link/src";
import { focusOutline, useTheme } from "../../theme/src";
const AnimatedBox = animated(Box);
export const Tag = (_a) => {
    var { href, label, name, onClick, selected = false } = _a, otherProps = __rest(_a, ["href", "label", "name", "onClick", "selected"]);
    const theme = useTheme();
    const isClickable = href || onClick;
    const initialStyle = useMemo(() => ({
        backgroundColor: selected ? theme.colors.primary : theme.colors.white,
        borderColor: selected ? theme.colors.primary : theme.colors.horizon,
        color: selected ? theme.colors.white : theme.colors.asphalt,
    }), [selected, theme]);
    const hoverStyle = useMemo(() => ({
        backgroundColor: theme.colors.primaryDark,
        borderColor: theme.colors.primaryDark,
        color: theme.colors.white,
    }), [theme]);
    const [spring, springApi] = useSpring(() => initialStyle);
    const onMouseLeave = useCallback(() => springApi.start(initialStyle), [initialStyle, springApi]);
    const onMouseEnter = useCallback(() => springApi.start(hoverStyle), [hoverStyle, springApi]);
    const handleOnClick = useMemo(() => onClick &&
        ((event) => {
            event.preventDefault();
            onClick(name);
        }), [name, onClick]);
    const handleKeyPress = useMemo(() => (handleOnClick ? onEnterOrSpacePress(handleOnClick) : undefined), [handleOnClick]);
    useEffect(() => {
        springApi.start(initialStyle);
    }, [selected, initialStyle, springApi]);
    const commonProps = {
        $isClickable: isClickable,
        onMouseEnter,
        onMouseLeave,
        selected,
        style: spring,
    };
    return href ? (_jsx(LinkSimple, { style: { display: 'inline-block' }, to: href, children: _jsx(TagWrapper, Object.assign({}, commonProps, otherProps, { children: label !== null && label !== void 0 ? label : name })) })) : (_jsx(TagWrapper, Object.assign({}, commonProps, { onClick: handleOnClick, onKeyPress: handleKeyPress, tabIndex: isClickable ? 0 : -1 }, otherProps, { children: label !== null && label !== void 0 ? label : name })));
};
const getBorder = (theme) => `1px solid ${theme.colors.horizon}`;
const TagWrapper = styled(AnimatedBox).attrs({
    font: 'body-semibold-asphalt',
    maxWidth: '200px',
    minHeight: '32px',
    pb: '6px',
    pt: '7px',
    px: 3,
}) `
  ${flexbox}
  ${focusOutline}
  ${space}
  ${layout}
  align-items: center;
  border-radius: 5px;
  border: ${({ theme }) => getBorder(theme)};
  display: block;
  justify-content: center;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: fit-content;
  cursor: ${(props) => (props.$isClickable ? 'pointer' : 'auto')};
  pointer-events: ${(props) => (props.$isClickable ? 'all' : 'none')};
`;
//# sourceMappingURL=Tag.js.map